<template>
  <div>
    <ServerError v-if="ServerError" />
    <v-layout wrap class="hidden-sm-and-down">
      <v-flex>
        <v-card color="#fff" tile flat>
          <v-app-bar color="#fff" dark dense elevation="1">
            <v-layout wrap text-center justify-center md6>
              <v-flex>
                <v-btn light text class="Filter_Menu" @click="reloadPage">All</v-btn>
              </v-flex>
              <v-flex v-for="(item,i) in categories" :key="i">
                <v-btn light text class="Filter_Menu" @click="setCategory(item)">{{item.name}}</v-btn>
              </v-flex>
              <v-flex v-if="appLogin">
                <v-btn light text class="Filter_Menu" @click="getBookmarks">Bookmarks</v-btn>
              </v-flex>
            </v-layout>
          </v-app-bar>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
import store from "./../../store";
export default {
  data() {
    return {
      categories: [],
      ServerError: false
    };
  },
  computed: {
    appLogin() {
      return store.state.isLoggedIn;
    }
  },
  beforeMount() {
    this.getCategory();
  },
  methods: {
    reloadPage() {
      window.location.reload();
    },
    getCategory() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/project/category/getlist"
      })
        .then(response => {
          this.appLoading = false;
          this.categories = response.data.data;
        })
        .catch(err => {
          this.msg = err;
          this.ServerError = true;
        });
    },
    setCategory(item) {
      this.$emit("stepper", {
        clearFilter: false,
        category: item,
        tag: []
      });
    },
    getBookmarks() {
      this.$emit("bookmarks", {
        clearFilter: false,
        bookmark: true
      });
    }
  }
};
</script>
<style scoped>
.Filter_Menu {
  font-family: opensans_Regular;
  font-size: 12px;
  font-weight: 400;
}
</style>